// store/actions/ReceptionistAppointmentActions.js
import {
    GET_BOOKED_APPOINTMENTS_REQUEST,
    GET_BOOKED_APPOINTMENTS_SUCCESS,
    GET_BOOKED_APPOINTMENTS_FAILURE,
 
  } from "../types/AppoinmentTypes"
  
  import {
    getBookedAppointments,

    formatBookedAppointments
  } from "../../services/AppoinmentService";
  
  import { handleSuccess, showErrorAlert } from "../../services/ErrorHandlingService";
  
  // Get Booked Appointments Action (with is_payment: "Yes", is_confirmed: "Yes")
  export const getBookedAppointmentsAction = (date, doctor_id = null) => {
    return async (dispatch) => {
      console.log("📅 Fetching booked appointments:", { date, doctor_id });
  
      dispatch({ type: GET_BOOKED_APPOINTMENTS_REQUEST });
      
      try {
        const response = await getBookedAppointments(date, doctor_id);
        console.log("API Response:", response.data);
  
        // Format the appointments using your formatter
        const formattedAppointments = formatBookedAppointments(response.data);
  
        if (response.data?.status === "success" || response.data) {
          dispatch({
            type: GET_BOOKED_APPOINTMENTS_SUCCESS,
            payload: formattedAppointments,
          });
          
          return { 
            status: "success", 
            data: formattedAppointments,
            message: response.data?.message || "Appointments fetched successfully"
          };
        } else {
          throw new Error(response.data?.message || "Failed to fetch appointments");
        }
      } catch (error) {
        dispatch({
          type: GET_BOOKED_APPOINTMENTS_FAILURE,
          payload: error.message,
        });
        showErrorAlert(error.message);
        throw error;
      }
    };
  };
  
  // Reschedule Appointment Action

  // Cancel Appointment Action

  // Get Available Slots Action
 